/* ============================================================
   Wishlist and registry page rendering.
   Generated by scripts/build_theme_registry.py. Do not edit here.
   Loaded only on the two templates that need it, so the site-wide
   bundle stays the heart and nothing else.
   ============================================================ */
(function () {
  'use strict';

  // Runs as soon as registry.js has published its helpers, whichever of the
  // two deferred scripts the browser reaches first.
  if (window.UBReg) start();
  else document.addEventListener('ub:reg-ready', start, { once: true });

  function start() {
  var R = window.UBReg;
  if (!R) return;

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var el = function (html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstElementChild; };
  var qs = new URLSearchParams(location.search);

  /* A due date is the one date a parent is counting down to, so it is spelled
     out rather than shown as a number. */
  function niceDate(d) {
    if (!d) return '';
    var t = new Date(d + 'T00:00:00');
    if (isNaN(t)) return '';
    return t.toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
  }

  /* "14 weeks to go": the number a parent actually has in their head. */
  function weeksTo(d) {
    if (!d) return '';
    var t = new Date(d + 'T00:00:00');
    if (isNaN(t)) return '';
    var days = Math.round((t - new Date()) / 864e5);
    if (days < -14) return '';
    if (days <= 0) return 'Any day now';
    if (days < 14) return days + ' day' + (days === 1 ? '' : 's') + ' to go';
    return Math.round(days / 7) + ' weeks to go';
  }

  /* The essentials rail on the landing page. Handles come from the section
     settings so the team can change the line-up in the editor; everything
     shown is fetched live so the price is the store's price. Cards carry
     .tile, so registry.js decorates each with a working heart. */
  var railHost = document.querySelector('[data-registry]');
  var rail = document.querySelector('[data-picks-rail]');
  if (rail && railHost && !document.documentElement.classList.contains('reg-has-token')) renderPicks();

  function renderPicks() {
    var handles = (railHost.getAttribute('data-picks') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var whys = (railHost.getAttribute('data-picks-why') || '').split(',').map(function (h) { return h.trim(); });
    if (!handles.length) { rail.parentNode.hidden = true; return; }
    Promise.all(handles.map(R.product)).then(function (rows) {
      var html = '';
      rows.forEach(function (p, i) {
        if (!p) return;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        html += '<a class="tile" href="/products/' + esc(p.handle) + '">'
          + '<figure><img src="' + esc(p.featured_image || (p.images || [])[0] || '') + '" alt="" loading="lazy"></figure>'
          + '<div class="txt">'
          + (whys[i] ? '<span class="why">' + esc(whys[i]) + '</span>' : '')
          + '<h3>' + esc((p.title || '').replace(/^UPPAbaby /, '').replace(/\s+-\s+.*$/, '')) + '</h3>'
          + '<p class="price">' + esc(R.money(v ? v.price : p.price)) + '</p>'
          + '</div></a>';
      });
      if (!html) { rail.parentNode.hidden = true; return; }
      rail.innerHTML = html;
      if (R.decorate) R.decorate(rail);
    });
  }

  function cardShell(o) {
    return '<article class="reg-card' + (o.done ? ' is-done' : '') + '">'
      + '<a href="/products/' + esc(o.handle) + '">'
      + '<figure>' + (o.image ? '<img src="' + esc(o.image) + '" alt="' + esc(o.title) + '" loading="lazy">' : '') + '</figure>'
      + '</a>'
      + '<h3><a href="/products/' + esc(o.handle) + '">' + esc(o.title) + '</a></h3>'
      + (o.variantTitle && o.variantTitle !== 'Default Title' ? '<p class="vt">' + esc(o.variantTitle) + '</p>' : '')
      + '<p class="price">' + esc(o.price) + '</p>'
      + (o.need || '')
      + '<div class="acts">' + (o.acts || '') + '</div>'
      + '</article>';
  }

  /* ================================================================
     Saved items
     ================================================================ */
  var wrap = document.querySelector('[data-wishlist]');
  if (wrap) renderWishlist();

  function renderWishlist() {
    var mount = wrap.querySelector('[data-wish-list]');
    var cta = wrap.querySelector('[data-wish-cta]');
    var handles = R.wish.all();

    if (!handles.length) {
      mount.innerHTML = '<div class="reg-empty">'
        + '<h2 class="d3">Nothing saved yet</h2>'
        + '<p>Tap the heart on anything you are considering and it will wait for you here. '
        + 'Saved items live on this device, so there is no account to make.</p>'
        + '<a class="btn btn-slate" href="/collections/prams-strollers">Browse the prams</a>'
        + '</div>';
      if (cta) cta.hidden = true;
      return;
    }

    Promise.all(handles.map(R.product)).then(function (rows) {
      var html = '';
      rows.forEach(function (p, i) {
        // A product that has been unpublished since it was saved returns
        // nothing. Drop it quietly rather than rendering a broken card.
        if (!p) { R.wish.remove(handles[i]); return; }
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        var acts = '';
        if (v && v.available) {
          acts += '<button type="button" class="btn btn-slate" data-add="' + v.id + '">Add to bag</button>';
        } else {
          acts += '<a class="btn btn-linedark" href="/products/' + esc(p.handle) + '">View</a>';
        }
        acts += '<button type="button" class="btn btn-linedark" data-unsave="' + esc(p.handle) + '">Remove</button>';
        html += cardShell({
          handle: p.handle,
          title: (p.title || '').replace(/^UPPAbaby /, ''),
          image: p.featured_image || (p.images || [])[0],
          price: R.money(p.price),
          acts: acts
        });
      });
      mount.innerHTML = html ? '<div class="reg-grid">' + html + '</div>' : '';
      if (!html) return renderWishlist();
      if (cta) cta.hidden = false;
    });

    mount.addEventListener('click', function (e) {
      var b = e.target.closest('[data-unsave]');
      if (!b) return;
      R.wish.remove(b.getAttribute('data-unsave'));
      renderWishlist();
    });
  }

  /* ================================================================
     Registry
     ================================================================ */
  var host = document.querySelector('[data-registry]');
  if (!host) return;
  var mount = host.querySelector('[data-registry-mount]');

  var shareTok = qs.get('r');
  var manageTok = qs.get('manage');
  var fromStorage = false;
  if (!shareTok && !manageTok) {
    var saved = R.reg.get();
    if (saved) { manageTok = saved.manageToken; fromStorage = true; }
  }

  if (shareTok || manageTok) load(shareTok || manageTok);
  else createForm();

  /* A remembered registry that the server no longer knows about (a test list
     that was cleared, a browser that kept a token from an earlier build)
     must not lock the parent out of the page with an error they cannot act
     on. Forget it, show the landing page, and let them start again. A share
     link or an explicit manage link that fails is a real dead link and keeps
     its message. */
  function forgetAndRestart() {
    R.reg.clear();
    document.documentElement.classList.remove('reg-has-token');
    if (rail && railHost) renderPicks();
    createForm();
  }

  function head(eyebrow, h1, body) {
    return '<div class="reg-head"><span class="label">' + esc(eyebrow) + '</span>'
      + '<h1 class="d1">' + esc(h1) + '</h1>'
      + (body ? '<p>' + esc(body) + '</p>' : '') + '</div>';
  }

  function fail(msg) {
    mount.innerHTML = head('Registry', 'We could not open that registry',
        (msg || '') + ' Check the link you were sent is complete, or ask the person who sent it to copy it again from their registry page.')
      + '<a class="btn btn-slate" href="/pages/registry">Start your own registry</a>';
  }

  function load(token) {
    mount.innerHTML = head('Registry', host.getAttribute('data-heading') || 'Your baby registry', '')
      + '<div class="reg-empty"><p>Loading the list.</p></div>';
    R.api('/' + encodeURIComponent(token)).then(function (res) {
      if (!res || !res.ok) {
        var savedNow = R.reg.get();
        var isSaved = savedNow && savedNow.manageToken === token;
        // The remembered token is dead: a 404 from the API. A network failure
        // or a server error is not a reason to forget a registry.
        if (isSaved && res && /valid|not found/i.test(res.error || '')) return forgetAndRestart();
        if (fromStorage && res && /valid|not found/i.test(res.error || '')) return forgetAndRestart();
        return fail((res && res.error) || 'That link is not valid any more.');
      }
      // Landing on a manage link on a new device is how a parent gets back in
      // after clearing their browser, so remember it here rather than only at
      // the moment the registry was created.
      if (res.owned) R.reg.set({ manageToken: res.registry.manageToken, shareToken: res.registry.shareToken, ownerName: res.registry.ownerName });
      // Arrived from a product page with "Add to my registry". Add it, drop
      // the parameter from the address so a refresh cannot add it twice, then
      // show the list with the new item in it.
      var addHandle = qs.get('add');
      if (res.owned && addHandle) {
        qs.delete('add');
        history.replaceState(null, '', location.pathname + '?' + qs.toString());
        var already = res.items.some(function (i) { return i.handle === addHandle; });
        if (already) return ownerView(res);
        return addOne(res.registry.manageToken, addHandle).then(function () { load(res.registry.manageToken); });
      }
      res.owned ? ownerView(res) : guestView(res);
    });
  }

  function banner(res, owned) {
    var g = res.registry;
    var names = [g.ownerName, g.partnerName].filter(Boolean).join(' and ');
    var pct = res.progress.wanted ? Math.round(res.progress.purchased / res.progress.wanted * 100) : 0;
    var left = Math.max(0, res.progress.wanted - res.progress.purchased);
    var meta = '';
    if (g.dueDate) meta += '<div><b>Due</b>' + esc(niceDate(g.dueDate)) + '</div>';
    if (g.shipSuburb) meta += '<div><b>Delivering to</b>' + esc([g.shipSuburb, g.shipState].filter(Boolean).join(', ')) + '</div>';
    var wk = weeksTo(g.dueDate);
    if (wk) meta += '<div><b>Countdown</b>' + esc(wk) + '</div>';

    var share = '';
    if (owned) {
      var url = location.origin + '/pages/registry?r=' + encodeURIComponent(g.shareToken);
      share = '<div class="reg-share">'
        + '<input type="text" readonly value="' + esc(url) + '" data-share-url aria-label="Your registry link">'
        + '<button type="button" class="btn btn-slate" data-copy>Copy link</button>'
        + '</div>';
    }

    return '<div class="reg-hero g-slate">'
      + '<div class="reg-hero-grid">'
      + '<div>'
      + '<p class="label">' + (owned ? 'Your registry' : 'Baby registry') + '</p>'
      + '<h2>' + esc((names || (owned ? 'Your' : 'A')) + '’s registry') + '</h2>'
      + (g.greeting ? '<p class="greet">' + esc(g.greeting) + '</p>' : (owned ? '<p class="greet">Send the link below to your family. Anything bought drops off the list on its own.</p>' : '<p class="greet">Here is what they still need. Buy from this page and it comes off the list for everyone.</p>'))
      + '<div class="meta">' + meta + '</div>'
      + share
      + '</div>'
      + '<div class="reg-stat">'
      + '<p class="big">' + res.progress.purchased + '<small>of ' + res.progress.wanted + '</small></p>'
      + '<p class="cap">' + (res.progress.wanted ? (left ? left + ' gift' + (left === 1 ? '' : 's') + ' still needed' : 'Everything has been bought') : 'No gifts on the list yet') + '</p>'
      + '<div class="reg-bar"><i style="width:' + pct + '%"></i></div>'
      + '</div>'
      + '</div>'
      + '</div>';
  }

  /* ---------- what the family sees ---------- */
  function guestView(res) {
    var g = res.registry;
    var cards = res.items.map(function (i) {
      var done = i.remaining <= 0;
      var need;
      if (done && i.purchased >= i.wanted) need = '<p class="reg-need is-done"><i class="dot"></i>Already bought</p>';
      else if (done) need = '<p class="reg-need is-held"><i class="dot"></i>Someone is buying this right now</p>';
      else need = '<p class="reg-need"><i class="dot"></i>' + i.remaining + ' still needed</p>';

      var acts = done
        ? '<a class="btn btn-linedark" href="/products/' + esc(i.handle) + '">View it</a>'
        : '<button type="button" class="btn btn-slate" data-gift="' + esc(i.id) + '" data-variant="' + esc(i.variantId) + '">Buy this gift</button>';
      return cardShell({
        handle: i.handle, title: i.title, variantTitle: i.variantTitle,
        image: i.image, price: R.money(i.priceCents), done: done,
        need: need + (i.note ? '<p class="vt">' + esc(i.note) + '</p>' : ''), acts: acts
      });
    }).join('');

    mount.innerHTML = head('Registry', 'A gift for ' + (g.ownerName || 'the family'),
        'Everything here was chosen by them. Buy from this page and it comes off the list, so nobody buys the same thing twice.')
      + banner(res, false)
      + (cards ? '<div class="reg-grid">' + cards + '</div>'
               : '<div class="reg-empty"><p>Nothing has been added to this registry yet. Try again in a few days.</p></div>');

    mount.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gift]');
      if (!b) return;
      b.disabled = true;
      var label = b.textContent;
      b.textContent = 'Adding…';
      // The hold goes first. If the browser dies between here and the cart the
      // hold expires by itself, which is the safe way round: a gift briefly
      // unavailable is better than two prams.
      R.api('/hold', { method: 'POST', body: JSON.stringify({ shareToken: g.shareToken, itemId: b.getAttribute('data-gift'), quantity: 1 }) })
        .then(function () { return R.addGift(b.getAttribute('data-variant'), g.shareToken, b.getAttribute('data-gift'), 1); })
        .then(function () {
          b.textContent = 'In your bag';
          if (window.UBCart) window.UBCart.open();
        })
        .catch(function (err) {
          b.disabled = false; b.textContent = label;
          alert((err && err.message) || 'That could not be added. It may have just sold out.');
        });
    });
  }

  /* ---------- what the parent sees ---------- */
  function ownerView(res) {
    var g = res.registry;
    var savedCount = R.wish.count();
    var cards = res.items.map(function (i) {
      var need = i.purchased > 0
        ? '<p class="reg-need is-done"><i class="dot"></i>' + i.purchased + ' of ' + i.wanted + ' bought</p>'
        : '<p class="reg-need"><i class="dot"></i>' + i.wanted + ' wanted</p>';
      var acts = '<div class="reg-qty">'
        + '<button type="button" data-qty="-1" data-item="' + esc(i.id) + '" aria-label="One fewer">−</button>'
        + '<span>' + i.wanted + '</span>'
        + '<button type="button" data-qty="1" data-item="' + esc(i.id) + '" aria-label="One more">+</button>'
        + '</div>'
        + '<button type="button" class="btn btn-linedark" data-drop="' + esc(i.id) + '">Remove</button>';
      return cardShell({
        handle: i.handle, title: i.title, variantTitle: i.variantTitle,
        image: i.image, price: R.money(i.priceCents), need: need, acts: acts
      });
    }).join('');

    mount.innerHTML = head('Your registry', 'Your baby registry',
        'This is your view. Your family sees the link below, and never sees who bought what.')
      + banner(res, true)
      + (savedCount ? '<p class="reg-note">You have ' + savedCount + ' saved item' + (savedCount === 1 ? '' : 's')
          + '. <button type="button" class="btn btn-linedark" data-import>Add them to the registry</button></p>' : '')
      + (cards ? '<div class="reg-grid">' + cards + '</div>'
               : '<div class="reg-empty"><h2 class="d3">Nothing on the list yet</h2>'
                 + '<p>Add anything from the shop with the heart, then bring your saved items across here.</p>'
                 + '<a class="btn btn-slate" href="/collections/prams-strollers">Browse the prams</a></div>');

    mount.addEventListener('click', function (e) {
      var copy = e.target.closest('[data-copy]');
      if (copy) {
        var input = mount.querySelector('[data-share-url]');
        input.select();
        var done = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy link'; }, 2000); };
        if (navigator.clipboard) navigator.clipboard.writeText(input.value).then(done, done);
        else { try { document.execCommand('copy'); done(); } catch (err) {} }
        return;
      }
      var drop = e.target.closest('[data-drop]');
      if (drop) {
        drop.disabled = true;
        R.api('/items', { method: 'POST', body: JSON.stringify({ manageToken: g.manageToken, action: 'remove', itemId: drop.getAttribute('data-drop') }) })
          .then(function () { load(g.manageToken); });
        return;
      }
      var qty = e.target.closest('[data-qty]');
      if (qty) {
        var card = qty.closest('.reg-qty');
        var span = card.querySelector('span');
        var next = Math.max(1, Math.min(20, parseInt(span.textContent, 10) + parseInt(qty.getAttribute('data-qty'), 10)));
        span.textContent = next;
        R.api('/items', { method: 'POST', body: JSON.stringify({ manageToken: g.manageToken, action: 'update', itemId: qty.getAttribute('data-item'), wanted: next }) });
        return;
      }
      var imp = e.target.closest('[data-import]');
      if (imp) {
        imp.disabled = true; imp.textContent = 'Adding…';
        importSaved(g.manageToken).then(function () { load(g.manageToken); });
      }
    });
  }

  /* Brings the saved list across. One request per product because each needs
     its live price and variant, and a parent has tens of saved items, not
     thousands. */
  function addOne(manageToken, h) {
    return R.product(h).then(function (p) {
      if (!p) return;
      var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
      if (!v) return;
      return R.api('/items', {
        method: 'POST',
        body: JSON.stringify({
          manageToken: manageToken, action: 'add',
          variantId: String(v.id), productId: String(p.id), handle: p.handle,
          title: (p.title || '').replace(/^UPPAbaby /, ''),
          variantTitle: v.title, image: p.featured_image || (p.images || [])[0],
          priceCents: v.price, wanted: 1
        })
      });
    });
  }

  function importSaved(manageToken) {
    var handles = R.wish.all();
    return handles.reduce(function (chain, h) {
      return chain.then(function () { return addOne(manageToken, h); });
    }, Promise.resolve());
  }

  /* ---------- creating one ----------
     Built on the site's own .pform / .field system rather than a bespoke one,
     so it matches every other form and inherits their focus, error and select
     behaviour for free. The aside mirrors the fields as they are typed: being
     asked to name and date a registry before you have seen one is abstract,
     and this makes it concrete at the moment of the decision. */
  function createForm() {
    mount.innerHTML = head('Start', host.getAttribute('data-heading') || 'Start your baby registry',
        host.getAttribute('data-body') || 'One list, one link. Your family can see what you still need, and anything already bought drops off so nobody doubles up.')
      + '<div class="form-split">'
      + '<form class="pform" data-create novalidate>'
      +   '<div class="pform-head">'
      +     '<h2>Tell us who it is for</h2>'
      +     '<p>Six fields, and only the first two are needed. Everything here can be changed later.</p>'
      +   '</div>'
      +   '<div data-err></div>'

      +   '<fieldset class="fset"><legend>Your family</legend>'
      +     '<div class="formgrid">'
      +       field('ownerName', 'Your name', { required: true, autocomplete: 'name', max: 120 })
      +         field('partnerName', 'Partner’s name', { autocomplete: 'name', max: 120, hint: 'Optional. Both names appear on the registry.' })
      +         field('ownerEmail', 'Your email', { required: true, type: 'email', autocomplete: 'email', max: 200, wide: true, hint: 'We send your private edit link here. It is the only way back in, so use an address you will still have in six months.' })
      +     '</div>'
      +   '</fieldset>'

      +   '<fieldset class="fset"><legend>The details your family sees</legend>'
      +     '<div class="formgrid">'
      +       field('dueDate', 'Due date', { type: 'date', hint: 'Optional.' })
      +         field('shipSuburb', 'Suburb', { autocomplete: 'address-level2', max: 120, hint: 'Optional. Your street address is never shown.' })
      +         field('greeting', 'A note for your family', { textarea: true, max: 600, wide: true, placeholder: 'Anything you would like them to know.' })
      +     '</div>'
      +   '</fieldset>'

      +   '<div class="pform-foot">'
      +     '<button type="submit" class="btn btn-slate">Create my registry</button>'
      +     '<p>Nothing is shared until you send the link yourself.</p>'
      +   '</div>'
      + '</form>'

      + '<aside>' + previewCard() + '</aside>'
      + '</div>';

    var form = mount.querySelector('[data-create]');
    bindPreview(form);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var errBox = form.querySelector('[data-err]');
      errBox.innerHTML = '';
      var data = {};
      [].forEach.call(form.elements, function (f) { if (f.name) data[f.name] = f.value.trim(); });

      if (!data.ownerName || !data.ownerEmail) {
        errBox.innerHTML = msg('bad', 'Your name and your email are both needed.');
        (data.ownerName ? form.elements.ownerEmail : form.elements.ownerName).focus();
        return;
      }
      var btn = form.querySelector('button[type=submit]');
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Creating your registry…';

      R.api('/create', { method: 'POST', body: JSON.stringify(data) }).then(function (res) {
        if (!res || !res.ok) {
          errBox.innerHTML = msg('bad', (res && res.error) || 'That did not save. Please try again.');
          btn.removeAttribute('aria-busy');
          btn.textContent = 'Create my registry';
          return;
        }
        R.reg.set({ manageToken: res.manageToken, shareToken: res.shareToken, ownerName: res.ownerName });
        /* Arrived from a product page with "Add to a baby registry": carry the
           pram through so the new list opens with it already on it, rather
           than empty and asking them to go and find it again. */
        var carry = new URLSearchParams(location.search).get('from');
        location.href = '/pages/registry?manage=' + encodeURIComponent(res.manageToken)
          + (carry ? '&add=' + encodeURIComponent(carry) : '');
      });
    });
  }

  /* One field, on the shared .field markup the rest of the site uses. */
  function field(name, label, o) {
    o = o || {};
    var id = 'f-' + name;
    var control = o.textarea
      ? '<textarea id="' + id + '" name="' + name + '" maxlength="' + (o.max || 300) + '"'
        + (o.placeholder ? ' placeholder="' + esc(o.placeholder) + '"' : '') + '></textarea>'
      : '<input id="' + id + '" name="' + name + '" type="' + (o.type || 'text') + '"'
        + (o.required ? ' required' : '')
        + (o.autocomplete ? ' autocomplete="' + o.autocomplete + '"' : '')
        + ' maxlength="' + (o.max || 200) + '"'
        + (o.placeholder ? ' placeholder="' + esc(o.placeholder) + '"' : '') + '>';
    return '<div class="field' + (o.wide ? ' wide' : '') + '">'
      + '<label for="' + id + '">' + esc(label) + (o.required ? ' <span aria-hidden="true">*</span>' : '') + '</label>'
      + control
      + (o.hint ? '<p class="hint">' + esc(o.hint) + '</p>' : '')
      + '</div>';
  }

  function msg(kind, text) {
    var icon = kind === 'bad' ? 'i-info' : 'i-verified';
    return '<div class="fmsg is-' + (kind === 'bad' ? 'bad' : 'good') + '">'
      + '<svg class="ico" aria-hidden="true"><use href="#' + icon + '"></use></svg>'
      + '<span>' + esc(text) + '</span></div>';
  }

  function previewCard() {
    return '<div class="reg-preview">'
      + '<div class="cap"><i></i>What your family will see</div>'
      + '<div class="body">'
      +   '<h3 data-p-title><span class="ghost">Your</span> registry</h3>'
      +   '<p class="greet" data-p-greet><span class="ghost">Your note to them appears here.</span></p>'
      +   '<div class="facts" data-p-facts></div>'
      +   '<div class="rail"><i></i><i></i><i></i></div>'
      +   '<p class="note">They see what you still need and can buy it in one tap. '
      +     'They never see your email, your address, or who bought what.</p>'
      + '</div></div>';
  }

  function bindPreview(form) {
    var titleEl = mount.querySelector('[data-p-title]');
    var greetEl = mount.querySelector('[data-p-greet]');
    var factsEl = mount.querySelector('[data-p-facts]');
    if (!titleEl) return;

    var paint = function () {
      var v = function (n) { return (form.elements[n] && form.elements[n].value || '').trim(); };
      var names = [v('ownerName'), v('partnerName')].filter(Boolean).join(' and ');
      titleEl.innerHTML = names
        ? esc(names) + '’s registry'
        : '<span class="ghost">Your</span> registry';
      greetEl.innerHTML = v('greeting')
        ? esc(v('greeting'))
        : '<span class="ghost">Your note to them appears here.</span>';

      var facts = '';
      if (v('dueDate')) facts += '<div><b>Due</b>' + esc(niceDate(v('dueDate'))) + '</div>';
      if (v('shipSuburb')) facts += '<div><b>Delivering to</b>' + esc(v('shipSuburb')) + '</div>';
      facts += '<div><b>Gifts</b>0 of 0</div>';
      factsEl.innerHTML = facts;
    };
    form.addEventListener('input', paint);
    form.addEventListener('change', paint);
    paint();
  }
  }
})();
